var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoRenewConfirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F95108"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7398 31.7908C48.5398 31.8908 48.3398 32.0908 48.1398 32.2908C44.4398 35.9908 40.8398 39.5908 37.1398 43.2908C37.0398 43.3908 36.9398 43.5908 36.7398 43.6908L36.3398 43.2908L31.8398 38.7908C31.7398 38.6908 31.5398 38.4908 31.4398 38.3908C30.7398 37.8908 29.7398 37.8908 29.0398 38.3908C27.9398 39.2908 27.9398 40.6908 29.0398 41.6908C31.1398 43.7908 33.2398 45.7908 35.2398 47.8908C35.4398 48.0908 35.5398 48.1908 35.7398 48.2908C36.6398 48.7908 37.4398 48.5908 38.2398 47.7908C42.5398 43.5908 46.7398 39.2908 51.0398 35.0908C51.1398 34.9908 51.2398 34.8908 51.3398 34.7908C51.9398 34.0908 51.9398 32.7908 51.2398 32.0908C50.6398 31.3908 49.5398 31.1908 48.7398 31.7908Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoRenewConfirm);
export default __webpack_public_path__ + "static/media/auto-renew-confirm.8536db9cbc20be8f8ed6ea1ed1d2abac.svg";
export { ForwardRef as ReactComponent };